import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import { keysToCamelCase } from "lib/helpers";
import messages from "../messages";

function* cancelSubscriptionByAdmin(action) {
  const { userId: user_id, serviceSlug } = action.payload;
  const { success, data, error } = yield* makeRequest.post(`/services/${serviceSlug}/enrollment/cancel_by_admin`, {
    user_id,
  });
  if (success && data) {
    yield put(
      actions.newSuccessEvent({
        message: messages.CANCEL_SUBSCRIPTION_BY_ADMIN_SUCCESS,
      }),
    );
    yield put(
      actions.setDetailInUserDetails({
        enrollment: keysToCamelCase(data.body.enrollment),
      }),
    );
    yield put(
      actions.setDetailInUsersList({
        enrollment: keysToCamelCase(data.body.enrollment),
        id: user_id,
      }),
    );
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_CANCELING_SUBSCRIPTION_BY_ADMIN,
    });
  }

  return null;
}

export default cancelSubscriptionByAdmin;
